// Single-select view switch built from ds-chip toggles (the app's filter idiom).
// tabs: [{ key, label, count? }]
import "./Matching.css";

export default function ResultTabs({ tabs, active, onChange, label = "Result view" }) {
  return (
    <div className="mt-tabs" role="group" aria-label={label}>
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          className="ds-chip"
          aria-pressed={active === t.key}
          onClick={() => onChange(t.key)}
        >
          {t.label}
          {t.count != null && <span className="ds-chip-count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
